export { default } from './ToolCallsContent';
